<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_warehouse_no') || '库房编号'"
            prop="warehouseNo"
          >
            <el-input
              clearable
              v-model="formData.warehouseNo"
              :placeholder="
                $l('form_label_pe_warehouse_no') || '请输入库房编号'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_warehouse_description') || '库房描述'"
            prop="warehouseDescription"
          >
            <el-input
              clearable
              v-model="formData.warehouseDescription"
              :placeholder="
                $l('form_label_pe_warehouse_description') || '请输入库房描述'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_org_code') || '所属机构'"
            prop="orgCode"
          >
            <dict-select
              filterable
              clearable
              v-model="formData.orgCode"
              url="/master/masterWarehouse/select"
              :placeholder="$l('form_label_pe_org_code') || '所属机构'"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_warehouse_status') || '有效状态'"
            prop="warehouseStatus"
          >
            <br />
            <el-radio-group v-model="formData.warehouseStatus" :disabled="true">
              <el-radio label="Y">{{
                $l('INDEX.form_label_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('INDEX.form_label_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('form_label_create_by') || '创建人'"
            prop="createByName"
          >
            <el-input
              clearable
              v-model="formData.createByName"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('form_label_create_date') || '创建时间'"
            prop="createDate"
          >
            <el-input
              clearable
              v-model="formData.createDate"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('form_label_modify_by') || '修改人'"
            prop="modifyByName"
          >
            <el-input
              clearable
              v-model="formData.modifyByName"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('form_label_modify_date') || '修改时间'"
            prop="modifyDate"
          >
            <el-input
              clearable
              v-model="formData.modifyDate"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    warehouseCode: String,
    params: { type: Object, default: () => {} }
  },
  data() {
    return {
      formData: { warehouseStatus: 'Y' },
      rules: {
        warehouseNo: [
          {
            required: true,
            message: this.$l('form_label_pe_warehouse_no') || '请输入仓库编号',
            trigger: 'blur'
          }
        ],
        warehouseDescription: [
          {
            required: true,
            message:
              this.$l('form_label_pe_warehouse_description') ||
              '请输入库房描述',
            trigger: 'blur'
          }
        ],
        orgCode: [
          {
            required: true,
            message: this.$l('form_label_pe_org_code') || '请选择所属机构',
            trigger: 'change'
          }
        ],
        warehouseStatus: [
          {
            required: false,
            message: '请选择有效状态',
            trigger: 'change'
          }
        ],
        createByName: [
          {
            required: false,
            message: '请输入创建人',
            trigger: 'blur'
          }
        ],
        createDate: [
          {
            required: false,
            message: '请输入创建时间',
            trigger: 'blur'
          }
        ],
        modifyByName: [
          {
            required: false,
            message: '请输入修改人',
            trigger: 'blur'
          }
        ],
        modifyDate: [
          {
            required: false,
            message: '请输入修改时间',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.warehouseCode) return

      this.$api
        .masWarehouseDetailApi({
          warehouseCode: this.warehouseCode
        })
        .then((res) => {
          console.log(res.body)
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }

      this.loadingOpen()
      this.$api
        .masWarehouseSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    }
  }
}
</script>
